import { useLocation, useNavigate } from "react-router-dom";
import { PillTabs } from "@/components/common";
import { PATHS } from "@/lib/router";
import { useTran } from "@/hooks";
import { SlidersHorizontal, List } from "lucide-react";

const PATH_TO_TAB = {
  [PATHS.TARGET_SETUP_OVERVIEW]: "overview",
};

const TAB_TO_PATH = {
  "target-setup": PATHS.TARGET_SETUP,
  overview: PATHS.TARGET_SETUP_OVERVIEW,
};

const TargetSetupNavTabs = () => {
  const { t } = useTran();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const activeTab = PATH_TO_TAB[pathname] || "target-setup";

  const handleChange = (value) => {
    const path = TAB_TO_PATH[value] || PATHS.TARGET_SETUP;
    if (pathname !== path) navigate(path);
  };

  const tabs = [
    {
      value: "target-setup",
      label: t("Target Setup"),
      icon: SlidersHorizontal,
    },
    { value: "overview", label: t("Overview"), icon: List },
  ];

  return <PillTabs tabs={tabs} value={activeTab} onChange={handleChange} />;
};

export default TargetSetupNavTabs;
